module.exports = __webpack_public_path__ + "img/WorkPermit.ca915ae0.png";